import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=7dbac3ba&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=7dbac3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbac3ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbac3ba')) {
      api.createRecord('7dbac3ba', component.options)
    } else {
      api.reload('7dbac3ba', component.options)
    }
    module.hot.accept("./pay.vue?vue&type=template&id=7dbac3ba&scoped=true&", function () {
      api.rerender('7dbac3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/pay.vue"
export default component.exports